import { TextField } from '@mui/material';
import { grey } from '@mui/material/colors';
import PropTypes from 'prop-types';

export const InputField = (props) => {
  const {
    type,
    label,
    registration,
    error,
    helperText,
    id,
    name,
    autoComplete,
    autoFocus,
    disabled,
    multiline,
    defaultValue,
    rows,
    minRows,
    size,
    margin,
    align,
    placeholder,
    variant,
    InputProps,
    FormHelperTextProps,
    required,
    validation,
    editable,
    onBlur,
    onFocus,
    value,
  } = props;

  // number型の場合、スクロールによる値変更を防ぐ
  const handleWheel = (e) => {
    if (type === 'number') {
      e.target.blur();
      e.preventDefault();
    }
  };

  return (
    <TextField
      id={id}
      name={name}
      margin={margin}
      fullWidth
      label={label}
      type={type}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...registration}
      error={error}
      helperText={helperText}
      placeholder={disabled ? '' : placeholder || label}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      disabled={disabled}
      multiline={multiline}
      defaultValue={defaultValue}
      value={value}
      rows={rows}
      minRows={minRows}
      InputLabelProps={{
        shrink: true,
      }}
      size={size}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      inputProps={{
        ...validation,
        style: {
          textAlign: align,
        },
        onWheel: handleWheel,
      }}
      onBlur={onBlur}
      onFocus={onFocus}
      variant={variant}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      InputProps={InputProps}
      FormHelperTextProps={FormHelperTextProps}
      required={required}
      sx={{
        ...(!editable && {
          '& .Mui-disabled.MuiInputBase-root': {
            backgroundColor: grey[300],
          },
        }),
        ...{
          '& .Mui-disabled.MuiInputBase-input': {
            textFillColor: 'black',
          },
        },
        '& .MuiInputLabel-asterisk': {
          color: 'red',
        },
        // date型のプレースホルダー色を調整
        ...(type === 'date' && {
          '& input[type="date"]::-webkit-datetime-edit': {
            color: 'rgba(0, 0, 0, 0.38)',
          },
        }),
      }}
    />
  );
};

InputField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  registration: PropTypes.object,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  minRows: PropTypes.number,
  defaultValue: PropTypes.string,
  size: PropTypes.string,
  margin: PropTypes.string,
  align: PropTypes.string,
  placeholder: PropTypes.string,
  variant: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  InputProps: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  FormHelperTextProps: PropTypes.object,
  required: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  validation: PropTypes.object,
  editable: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

InputField.defaultProps = {
  type: 'text',
  label: '',
  error: false,
  helperText: '',
  autoComplete: '',
  autoFocus: false,
  disabled: false,
  multiline: false,
  defaultValue: '',
  registration: {},
  rows: undefined,
  minRows: undefined,
  size: 'medium',
  margin: 'normal',
  align: 'left',
  placeholder: '',
  variant: 'outlined',
  InputProps: undefined,
  FormHelperTextProps: undefined,
  required: false,
  validation: {},
  editable: false,
  onBlur: undefined,
  onFocus: undefined,
};
